module.exports = __webpack_public_path__ + "img/icon_info.c8223d09.png";